import { StorageEnum } from '../../context/storage';
import { ResolveStoredSessionChangeParams, StoredSessionChange } from '../types/login.types';

export const resolveStoredSessionChange = ({
  currentSessionId,
  storedUser,
}: ResolveStoredSessionChangeParams): StoredSessionChange => {
  const storedSessionId = storedUser?.[StorageEnum.SESSION_ID];

  if (!storedUser || !storedSessionId || storedSessionId === currentSessionId) {
    return 'ignore';
  }

  return 'reload';
};
